module.exports = __webpack_public_path__ + "static/cherry-d4c68a1fbd7d5e464dbe535a55e5dde0.png";